import { late, grossPay, totalPay, totalContri, grossBilling } from '../../functions/computations'

//generate columns for tanstack react table
//columns = ['emp_no']



/**
 * 
 * @param {*} columnTemplates  =  {
    "name": "EMP No",
    "value": "emp_no",
    "func": (row) => { return row.index }
  },

 * @param {*} selectedColumns  = ['emp_no']
 * @returns 
 */

export default function columnsGenerator(columnTemplates = [], selectedColumns = []) {
    if (columnTemplates.length === 0 || selectedColumns.length === 0)
        return []

    //generate column templates hash table
    /**
     * {
        "emp_no": {
            "header": "EMP No",
            accessorFn: (row) => {
                return row.index
            }
        },}
     * 
     */
    let columnTemplatesHashTable = columnTemplates.reduce((acc, currentTemplate) => {
        const key = currentTemplate.accessorKey ?? currentTemplate.accessorkey
        if (key == null || key === '') return acc
        acc[`${key}`] = {
            header: currentTemplate?.header || "N/A",
            accessorFn: currentTemplate?.accessorFn
        }

        return acc
    }, {})

    let unsortedColumns = selectedColumns.map((selectedColumn) => {
        //check if exist on column templates
        let columnTemplate = columnTemplatesHashTable[selectedColumn]

        if (columnTemplate)
            return {
                accessorKey: selectedColumn,
                header: columnTemplate.header,
                accessorFn: columnTemplate.accessorFn
            }
    })

    let columnTemplatesKeys = Object.keys(columnTemplatesHashTable)

    //we sort columns here
    let sortedColumns = []

    unsortedColumns.forEach((column) => {
        if (!column) return
        const accKey = column.accessorKey ?? column.accessorkey
        let columnIndex = columnTemplatesKeys.findIndex((columnTemplate) => {
            return columnTemplate === accKey
        })

        //we assign the column based on its index on columnTemplates
        if (columnIndex > -1)
            sortedColumns[columnIndex] = column
    })


    let sanitizedColumns = sortedColumns.filter(Boolean)

    

    return sanitizedColumns
}